/** Shown on refresh while persisted auth exists but `user` is not yet restored from JWT/profile. */
export function AuthHydrationFallback() {
  return (
    <div className="flex min-h-[50vh] w-full items-center justify-center text-sm text-muted-foreground">
      Loading…
    </div>
  );
}
